import { useQuery } from "@tanstack/react-query"
import seriesService from "services/series.service"
import type { TPricingSeries } from "types/modelNumbers.type"

export const useGetSeries = () => {
	return useQuery<TPricingSeries[]>({
		queryKey: ["getSeries"],
		queryFn: async () => {
			const { data } = await seriesService.getSeries()
			return data
		},
	})
}
